/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createManageProjectPageStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
  },
  h3: {
    color: theme.palette.primary.main,
    margin: '0 0 30px',
  },
  wrapperBreadcrumbs: {
    marginBottom: '20px',
  },
  tabsRoot: {
    marginBottom: '20px',
  },
  createButton: {
    textTransform: 'none',
    padding: '6px 4px',
    fontSize: '14px',
  },
  clusterModalText: {
    padding: '20px 20px 10px',
    textAlign: 'center',
  },
  clusterCreateButtons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    paddingTop: '15px',
  },
}));
